import { __extends } from "tslib";
import { TraitInfo } from './TraitInfo';
var MethodTraitInfo = /** @class */ (function (_super) {
    __extends(MethodTraitInfo, _super);
    function MethodTraitInfo(abc, kind, name, methodInfo) {
        var _this = _super.call(this, abc, kind, name) || this;
        _this.methodInfo = methodInfo;
        _this.method = null;
        return _this;
    }
    MethodTraitInfo.prototype.getMethodInfo = function () {
        return this.methodInfo;
    };
    MethodTraitInfo.prototype.resolve = function () {
        _super.prototype.resolve.call(this);
        if (typeof this.methodInfo === 'number') {
            this.methodInfo = this.abc.getMethodInfo(this.methodInfo);
        }
    };
    return MethodTraitInfo;
}(TraitInfo));
export { MethodTraitInfo };
